<template>
  <div class="pagination">
    <el-pagination
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size= "10"
            :page-count= "pageCount">
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: [ 'pageCount'],
  data() {
    return {
      // allDatas: this.allData
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.$emit('pageSize', val)
    }
  }
}
</script>

<style lang="less" type="text/less">
.pagination{
  .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #61aee6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue